import React from "react";
import { ShoppingBag } from "lucide-react";

export const StoreTeaser = () => {
  return (
    <section
      id="store"
      data-testid="store-section"
      className="relative py-24 md:py-40"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="relative overflow-hidden gold-border">
          {/* Glass panel */}
          <div className="absolute inset-0 bg-[#141311]/60 backdrop-blur-xl" />
          {/* Fine grid inside */}
          <div className="tapestry-weave absolute inset-0 opacity-40" />

          <div className="relative z-10 grid grid-cols-1 gap-10 p-10 md:grid-cols-[1fr_auto] md:items-center md:p-16">
            <div>
              <p className="eyebrow flex items-center gap-3">
                <ShoppingBag className="h-3.5 w-3.5" /> The Tapestry Store
              </p>
              <h2
                data-testid="store-heading"
                className="font-serif-display mt-4 text-4xl leading-tight text-[#F2EFEB] sm:text-5xl lg:text-6xl"
              >
                Wares are being <em className="italic text-[#C9A87C]">spun.</em>
              </h2>
              <p className="mt-6 max-w-xl text-base leading-relaxed text-[#A39D95]">
                Physical books, digital PDFs, character sheets, dice, GM
                screens, and limited runs of hand-woven bookmarks. The loom is
                warming. Subscribe to be told the day the doors open.
              </p>
            </div>

            <div className="flex items-center gap-4">
              <button
                type="button"
                disabled
                data-testid="store-cta-disabled"
                className="cursor-not-allowed rounded-none border border-[#C9A87C]/30 px-6 py-3 text-xs uppercase tracking-[0.24em] text-[#6E6A64]"
              >
                Coming Soon
              </button>
              <a
                href="#newsletter"
                data-testid="store-cta-notify"
                className="btn-ghost"
              >
                Notify Me
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StoreTeaser;
